import { render, staticRenderFns } from "./AllOrders.vue?vue&type=template&id=4d2ac18d&scoped=true&"
import script from "./AllOrders.vue?vue&type=script&lang=js&"
export * from "./AllOrders.vue?vue&type=script&lang=js&"
import style0 from "./AllOrders.vue?vue&type=style&index=0&id=4d2ac18d&lang=less&scoped=true&"
import style1 from "./AllOrders.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2ac18d",
  null
  
)

export default component.exports